export var setFilterDateFieldPlaceholder = function (e, dataFields) {
    if (e.parentType === "filterRow") {
        var isDate = dataFields.some(function (col) { return col === e.dataField; });
        if (isDate)
            e.editorOptions.placeholder = 'MM/DD/YYYY';
    }
};
